(() => {
  if (customElements.get('vt-seintje')) return;

  const REVISIE = '2024-10-15';

  function accountId() {
    const s = [...document.scripts].find((el) => /klaviyo\.js\?.*company_id=/.test(el.src));
    return s ? new URL(s.src).searchParams.get('company_id') : null;
  }

  class VtSeintje extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.veld = this.querySelector('input[type="email"]');
      this.knop = this.querySelector('button[type="submit"]');
      this.noot = this.querySelector('[role="status"]');
      this.standaard = this.noot.textContent;
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.verstuur();
      });
    }

    reset() {
      if (!this.noot) return;
      if (!this.standaard) this.standaard = this.noot.textContent;
      this.classList.remove('is-fout', 'is-klaar');
      this.noot.textContent = this.standaard;
      this.knop.disabled = false;
    }

    melding(tekst, soort) {
      this.classList.toggle('is-fout', soort === 'fout');
      this.classList.toggle('is-klaar', soort === 'klaar');
      this.noot.textContent = tekst;
    }

    async verstuur() {
      const email = this.veld.value.trim();
      if (!this.veld.checkValidity() || !email) {
        this.melding(this.dataset.ongeldig, 'fout');
        this.veld.focus();
        return;
      }
      const id = accountId();
      if (!id) {
        this.melding(this.dataset.fout, 'fout');
        return;
      }
      this.knop.disabled = true;
      try {
        const res = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(id)}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISIE },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                channels: ['EMAIL'],
                profile: { data: { type: 'profile', attributes: { email } } },
              },
              relationships: {
                variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${this.dataset.variant}` } },
              },
            },
          }),
        });
        if (!res.ok) throw new Error(String(res.status));
        this.melding(this.dataset.klaar, 'klaar');
      } catch {
        this.melding(this.dataset.fout, 'fout');
        this.knop.disabled = false;
      }
    }
  }

  customElements.define('vt-seintje', VtSeintje);
})();
